const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the Track Viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('journeyViewer', ['Application', 'Authorization', 'Journeys', 'UserJourneys', 'Analyze', 'Content', 'Assignments', function (Application, Authorization, Journeys, UserJourneys, Analyze, Content, Assignments) {
  return {
    restrict: 'E',
    scope: {},
    template: require('../../templates/directives/journey-viewer.html'),
    controller: ['$scope', function ($scope) {
      const self = this;
      self.features = Application.features.flags();

      if (!self.features.journeys) {
        Application.navigation.goTo('/explore');
      }

      self.user = Authorization.getAuthToken().user;
      self.contentType = 'journey';
      self.contentId = Application.navigation.getRouteParameters().id;
      self.loading = true;
      self.triggerRating = false;
      self.ratingTriggered = false;
      self.hideContentSummary = false;

      self.checkShowRating = () => {
        if (self.userJourney.satisfied_status === true && !self.ratingTriggered && (self.journey.rating_configuration && self.journey.rating_configuration.allow_rating)) {
          self.triggerRating = true;
          self.ratingTriggered = true;
        }
      }

      self.recordSurveyView = () => {
        Analyze.record({resource: 'views'}, {content: self.journey.surveys[0].survey_id, content_type: 'survey'});
      } 

      self.completeImportedContent = (importedContentId) => {
        const completionContexts = [{key: 'journey', value: self.contentId}];
        Content.complete({
          type: 'imported_content', 
          id: importedContentId,
          contexts: completionContexts
        });
      };

      self.backToJourney = async function() {
        self.userJourney = await UserJourneys.get({subresource: self.contentId, subsubresource: self.user._id}).$promise;
        self.journeyConfig.mapContentProgress();
        self.activeContent.contentActive = false;
        self.checkShowRating();
        $scope.$apply();
      }

      self.scormExit = function() {
        if (self.activeContent.contentActive) {
          self.backToJourney();
        }
      }

      self.pathLibrary = {
        firstPath: {'height': '4rem'},
        lastPath: {'height': '4rem'},
        top: {
          completed: {
            'border-left': 'solid 3px var(--primary)',
            'height': '6rem',
            'margin': '-2rem auto 0',
            'width': '0'
          },
          locked: {
            'border-left': 'dashed 3px gray',
            'margin': '-2rem auto 0',
            'height': '6rem',
            'width': '0'
          },
          available: {
            'border-left': 'dashed 3px var(--primary)',
            'height': '4rem',
            'margin': '0 auto',
            'width': '0'
          }
        },
        bottom: {
          completed: {
            'border-left': 'solid 3px var(--primary)',
            'height': '6rem',
            'margin': '0 auto 0',
            'width': '0'
          },
          locked: {
            'border-left': 'dashed 3px gray',
            'margin': '0 auto 0',
            'height': '6rem',
            'width': '0'
          },
          available: {
            'border-left': 'dashed 3px var(--primary)',
            'margin': '0 auto',
            'height': '4rem',
            'width': '0'
          }
        }
      }

      // Journey Progress Map
      // Each satisfiable entity has an object associated with its entity
      // that holds it's state (locked, available, or completed), the styles for the path
      // next to it in the display, its score if it's completed and has a score, and its index
      // in the journey
      // It's mapped on page load 

      self.journeyConfig = {
        progress: '0%',
        userProgress: {'width': '0%'},
        progressMap: {},
        availableIndex: 0,
        mapContentProgress: function() {    
          self.journeyConfig.availableIndex = 0;
          self.journey.satisfiable_entities.forEach((content, index) => {
            self.journeyConfig.assignState(content.entity, content.availability_delay_in_days, index);
            self.journeyConfig.pathStyle(content.entity, index);
            content.description = self.journeyConfig.handleDescription(content.entity_details);
          })
          self.journeyConfig.calculateOverallProgress();
        },
        handleDescription: function(details) {
          const description = details.summary || details.description;
          // Create a new div element
          var tempDivElement = document.createElement("div");
          
          // Set the HTML content with the given value
          tempDivElement.innerHTML = description;
          
          // Retrieve the text property of the element 
          return tempDivElement.textContent || tempDivElement.innerText || "";
        },
        getDateAvailable: function(contentDelay, index) {
          if (!contentDelay) {
            return;
          }
          // We're getting the id of the step before and then finding that id
          // in the userJourney satisfiable entities because we can't guarantee that the userJourney
          // satisfiable entities will be in the right order
          const lastSatisfactionId = self.journey.satisfiable_entities[index - 1].entity;
          const lastSatisfaction = self.userJourney.satisfiable_entities?.find(userEntity => userEntity.entity === lastSatisfactionId);

          if (!lastSatisfaction) {
            return;
          }

          const today = new Date();
          const lastSatisfactionDate = new Date(lastSatisfaction.satisfied_date);
          const daysSinceLastSatisfaction = moment(today).diff(lastSatisfactionDate, 'days');

          if (daysSinceLastSatisfaction < contentDelay) {
            const dateAvailable = moment(lastSatisfactionDate).add(contentDelay, 'days').format('MM/DD/YYYY');
            return dateAvailable;
          }
          return;
        },
        assignState: function(contentId, contentDelay, index) {
          self.journeyConfig.progressMap[contentId] = {};
          self.journeyConfig.progressMap[contentId].index = index;
          
          const selectedEntity = self.userJourney.satisfiable_entities && self.userJourney.satisfiable_entities.find(userEntity => userEntity.entity === contentId)
        
          if (selectedEntity?.satisfied_status && index === self.journeyConfig.availableIndex) {
            self.journeyConfig.progressMap[contentId].state = 'completed';
            self.journeyConfig.availableIndex = index + 1;
            return;
          }
          if (index === self.journeyConfig.availableIndex) {
            const dateAvailable = self.journeyConfig.getDateAvailable(contentDelay, index);
            if (dateAvailable && dateAvailable.length) {
              self.journeyConfig.progressMap[contentId].dateAvailable = dateAvailable;
              self.journeyConfig.progressMap[contentId].state = 'locked';
              return;
            }
            self.journeyConfig.progressMap[contentId].state = 'available';
            return;
          }  
          self.journeyConfig.progressMap[contentId].state = 'locked';
          
        },
        pathStyle: function(contentId, index) {
          const contentState = self.journeyConfig.progressMap[contentId].state;
          self.journeyConfig.progressMap[contentId].topPath = self.pathLibrary.top[contentState];
          self.journeyConfig.progressMap[contentId].bottomPath = self.pathLibrary.bottom[contentState];
          
          const previousState = self.journeyConfig.progressMap[self.journey.satisfiable_entities[index - 1]?.entity]?.state;
          if (contentState === 'locked' && previousState !== 'locked') {
            self.journeyConfig.progressMap[contentId].topPath = self.pathLibrary.top.available;
          }

          if (previousState && previousState === 'completed') {
            self.journeyConfig.progressMap[contentId].topPath = self.pathLibrary.top.completed;
          }

          if (index === 0) {
            self.journeyConfig.progressMap[contentId].topPath = self.pathLibrary.firstPath;
            self.journeyConfig.progressMap[contentId].firstStep = true;
          }
          if (index === self.journey.satisfiable_entities.length - 1) {
            self.journeyConfig.progressMap[contentId].bottomPath = self.pathLibrary.bottomPath;
            self.journeyConfig.progressMap[contentId].lastStep = true;
          }
        },
        calculateOverallProgress: function() {
          if (!self.userJourney.satisfiable_entities?.length) {
            return;
          }
          const satisfied = self.userJourney.satisfiable_entities.reduce((numberSatisfied, sE) => {
            if (sE.satisfied_status) {
              numberSatisfied++
            }
            return numberSatisfied;
          }, 0)

          const percentComplete = (Math.round((satisfied / self.journey.satisfiable_entities.length) * 100)).toString() + '%';
          self.journeyConfig.progress = percentComplete;
          self.journeyConfig.userProgress.width = percentComplete;
        },
        getPathIconColor: function(state) {
          if (state === 'locked') {
            return 'gray';
          }
          return 'var(--primary)';
        }
      }
    

      self.track = {
        landing: true,
        content: false,
        contentId: '',
        goTo: function(id) {
          if (!id) {
            self.track.landing = true;
            self.track.content = false;
            self.track.contentId = '';
            return;
          }
          self.track.contentId = id;
        },
        enterTrack: function(id) {
          self.track.landing = false;
          self.track.content = true;
          self.track.contentId = id;
        }
      }

      self.activeContent = {
        type: '',
        _id: '',
        contentActive: false,
        finalContent: false,
        startContent: function(content) {
          if (self.journeyConfig.progressMap[content.entity].state === 'locked') {
            return;
          }
          self.activeContent.type = content.type;
          self.activeContent._id = content.entity;
          self.activeContent.contentActive = true;
          
        }

      }

      // Get Journey
      self.initialize = async function() {
        try {
          const journey = await Journeys.get({subresource: self.contentId}).$promise;
          self.journey = journey;
          
          const userJourney = await UserJourneys.get({subresource: self.contentId, subsubresource: self.user._id}).$promise;
          self.userJourney = userJourney;

          if (!self.userJourney._id) {
            // Only assigned journeys should be accessible by users
            Application.navigation.goTo('/explore');
          }
          
          const assignments = await Assignments.search({assignee: self.user._id, content: self.contentId, fields: 'due_date'}).$promise;
          self.dueDate = assignments && assignments.length && assignments[0].due_date;

          self.journeyConfig.mapContentProgress();
          self.loading = false;
          self.checkShowRating();
        } catch (e) {
          console.log(e);
          Application.navigation.goTo('/explore');
        }
        $scope.$apply();
      }

      self.initialize();
    }],
    controllerAs: 'viewer'
  };
}]);